module.exports = __webpack_public_path__ + "static/media/Chaloner Wardrobes  (5).2bc00a9e.JPG";